import Vue from 'vue';
import Loader from '@/components/misc/loader.vue';
import PopupWrap from '@/components/misc/popup-wrap.vue';
import mainButton from '@/components/atoms/buttons/main/index.vue';
import imageSeo from '@/components/atoms/image-seo/index.vue';
import smallLoader from '@/components/misc/small-loader.vue';
import breadcrumbs from '@/components/breadcrumbs/index.vue'
import progressRing from '@/components/atoms/circle-progress/index.vue'
import VueApexCharts from "vue-apexcharts";

Vue.component('loader', Loader);
Vue.component('image-seo', imageSeo);
Vue.component('small-loader', smallLoader);
Vue.component('popup-wrap', PopupWrap);
Vue.component('breadcrumbs', breadcrumbs);
Vue.component('main-button', mainButton);
Vue.component('circle-progress', progressRing);
Vue.component('v-pagination', window['vue-plain-pagination']);
Vue.component('apexchart', VueApexCharts)

